module.exports = __webpack_public_path__ + "img/greenReadingArt1.03cf09ea.png";